import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const setMeta = (attr, key, val) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", val || "");
};

function apply(m) {
  if (m.title) document.title = m.title;
  setMeta("name", "description", m.description);
  setMeta("name", "robots", m.noindex ? "noindex, nofollow" : "index, follow");
  [["og:title", m.title], ["og:description", m.description], ["og:image", m.image], ["og:url", m.canonical], ["og:site_name", m.site_name], ["og:type", "website"]]
    .forEach(([k, v]) => setMeta("property", k, v));
  [["twitter:card", m.image ? "summary_large_image" : "summary"], ["twitter:title", m.title], ["twitter:description", m.description], ["twitter:image", m.image]]
    .forEach(([k, v]) => setMeta("name", k, v));
  let link = document.head.querySelector("link[rel='canonical']");
  if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
  link.href = m.canonical || window.location.href;
  document.getElementById("seo-jsonld")?.remove();
  if (m.jsonld) {
    const s = document.createElement("script");
    s.type = "application/ld+json"; s.id = "seo-jsonld"; s.text = JSON.stringify(m.jsonld);
    document.head.appendChild(s);
  }
}

export function SeoHead() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    const pitch = new URLSearchParams(search).get("pitch") || "";
    const t = setTimeout(() => api.get("/seo/meta", { params: { path: pathname, pitch } }).then((r) => apply(r.data)).catch(() => {}), 400);
    return () => clearTimeout(t);
  }, [pathname, search]);
  return null;
}
